import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Favorite, FavoriteRepository } from 'src-ironside/repositories/favorite.repository';

@Component({
    selector: 'app-modify-favorite',
    templateUrl: './modify-favorite.html',
    styleUrls: ['./modify-favorite.css'],
})
export class ModifyFavoriteComponent implements OnInit {
    @Output() onClose = new EventEmitter<Favorite>();

    form = new FormGroup({
        name: new FormControl('', [Validators.required]),
    });

    isEdit: boolean = false;
    loading: boolean = false;

    constructor(
        private favoriteRepository: FavoriteRepository,
        private dialogRef: MatDialogRef<ModifyFavoriteComponent>,
        @Inject(MAT_DIALOG_DATA) public data?: Favorite
    ) {
        this.isEdit = data ? true : false;

        if (this.isEdit) {
            this.form.get('name')?.setValue(data!.name || '');
        }
    }

    ngOnInit(): void {}
    valider() {
        if (!this.form.valid) {
            return;
        }
        this.loading = true;
        if (this.isEdit) {
            this.data!.name = this.form.get('name')?.value || '';
            this.favoriteRepository.edit(this.data!).subscribe({
                next: () => {
                    this.onClose.emit();
                    this.dialogRef.close(true);
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                },
            });
        } else {
            this.favoriteRepository.add(this.form.get('name')?.value || '').subscribe({
                next: (res) => {
                    this.onClose.emit(res);
                    this.dialogRef.close(true);
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                },
            });
        }
    }
}
